import { render } from "./PageDrop.vue?vue&type=template&id=31f3f64c&scoped=true"
import script from "./PageDrop.vue?vue&type=script&lang=js"
export * from "./PageDrop.vue?vue&type=script&lang=js"

import "./PageDrop.vue?vue&type=style&index=0&id=31f3f64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f3f64c"]])

export default __exports__